import React, { FC, useState } from "react";

import Button, { ButtonSize, ButtonTheme, ButtonVariant } from "@/components/ui/Button/Button";
import Icon from "@/components/ui/Icon/Icon";

type ShareState = "pending" | "success" | "error";

interface SharePopupProps {
  shareData: ShareData;
  onClose: () => void;
  onError?: (error?: unknown) => void;
}

const SharePopup: FC<SharePopupProps> = ({ shareData, onClose, onError }) => {
  const [state, setState] = useState<ShareState>("pending");

  const copyClicked = async () => {
    try {
      await navigator.clipboard.writeText(shareData?.url || "");
      setState("success");
    } catch (err) {
      onError && onError(err);
      setState("error");
    }
  };

  const getButtonText = (state: ShareState) => {
    switch (state) {
      case "success":
        return "Link copied";
      case "pending":
      default:
        return "Copy link";
    }
  };

  return (
    <div className="bg-white shadow-strong text-black rounded-lg p-m w-fit  max-w-xl">
      <div className="flex items-start gap-l">
        <h3>{shareData.title}</h3>
        <button onClick={onClose}>
          <span className="sr-only">Close Share</span>
          <div aria-hidden="true">
            <Icon name="close" size="24" title="close" className="stroke-black" />
          </div>
        </button>
      </div>
      <div className="flex flex-col md:flex-row items-center gap-xs justify-between">
        <input value={shareData.url} readOnly className="w-full" />

        <Button size={ButtonSize.MEDIUM} variant={ButtonVariant.PRIMARY} theme={ButtonTheme.BLACK} onClick={copyClicked} customClass="w-full">
          {getButtonText(state)}
        </Button>
      </div>
      {state === "error" ? <p className="text-status-error pt-xs">Unable to copy to clipboard, please manually copy the url to share.</p> : null}
    </div>
  );
};

export default SharePopup;
